<template>
    <CRow>
        <CCol col="12">
            <CCard class="content-health-detail">
                <CCardHeader class="content-health-detail__header">
                    <div class="content-health-detail__heading">
                        <CButton
                            color="secondary"
                            size="sm"
                            to="/content-health"
                        >К списку</CButton>
                        <div>
                            <div class="content-health-detail__title">{{ record.venueTitle || 'Карточка' }}</div>
                            <div class="content-health-detail__subtitle">{{ record.venueTypeTitle || 'Контент партнёров' }}</div>
                        </div>
                    </div>
                    <CBadge v-if="record.venueId" :color="record.ok ? 'success' : 'danger'">
                        {{ record.ok ? 'ок' : 'не ок' }}
                    </CBadge>
                </CCardHeader>

                <CCardBody v-if="loading" class="text-center py-5">
                    <CSpinner color="primary" />
                </CCardBody>

                <CCardBody v-else-if="record.venueId">
                    <table class="table table-striped content-health-detail__info">
                        <tbody>
                            <tr>
                                <th>Партнёр</th>
                                <td>
                                    <CLink v-if="record.partnerPath" :to="record.partnerPath">{{ record.partnerTitle || '—' }}</CLink>
                                    <span v-else>—</span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ record.venueTypeTitle || 'Карточка' }}</th>
                                <td>
                                    <CLink v-if="record.adminPath" :to="record.adminPath">{{ record.venueTitle || '—' }}</CLink>
                                    <span v-else>{{ record.venueTitle || '—' }}</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Проверено</th>
                                <td>{{ formatDate(record.checkedAt) }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="content-health-detail__stats">
                        <div class="content-health-detail__stat">
                            <div class="content-health-detail__stat-label">Обложка</div>
                            <div :class="statusClass(record.coverOk)">{{ statusText(record.coverOk) }}</div>
                        </div>
                        <div class="content-health-detail__stat">
                            <div class="content-health-detail__stat-label">Каталог</div>
                            <div :class="statusClass(record.catalogOk)">{{ statusText(record.catalogOk) }}</div>
                        </div>
                        <div class="content-health-detail__stat">
                            <div class="content-health-detail__stat-label">Картинки товаров</div>
                            <div :class="statusClass(record.picturesOk)">{{ statusText(record.picturesOk) }}</div>
                        </div>
                        <div class="content-health-detail__stat">
                            <div class="content-health-detail__stat-label">Без картинки</div>
                            <div class="content-health-detail__stat-value">{{ record.productMissingPicture }} из {{ record.productTotal }}</div>
                        </div>
                    </div>

                    <div class="content-health-detail__stats content-health-detail__stats--uptime">
                        <div class="content-health-detail__stat">
                            <div class="content-health-detail__stat-label">Аптайм 24 часа</div>
                            <div class="content-health-detail__stat-value">{{ formatUptime(record.uptime && record.uptime.h24) }}</div>
                        </div>
                        <div class="content-health-detail__stat">
                            <div class="content-health-detail__stat-label">Аптайм 7 дней</div>
                            <div class="content-health-detail__stat-value">{{ formatUptime(record.uptime && record.uptime.d7) }}</div>
                        </div>
                        <div class="content-health-detail__stat">
                            <div class="content-health-detail__stat-label">Аптайм 30 дней</div>
                            <div class="content-health-detail__stat-value">{{ formatUptime(record.uptime && record.uptime.d30) }}</div>
                        </div>
                    </div>

                    <section class="content-health-detail__section">
                        <h5>Причины</h5>
                        <ul v-if="reasonList(record.reasons).length" class="content-health-detail__reasons">
                            <li v-for="reason in reasonList(record.reasons)" :key="reason.code">{{ reason.message }}</li>
                        </ul>
                        <p v-else class="text-muted mb-0">Нет</p>
                    </section>

                    <section class="content-health-detail__section">
                        <h5>Позиции без картинки</h5>
                        <div v-if="problemRows.length" class="table-responsive">
                            <table class="table table-striped table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th>Позиция</th>
                                        <th class="content-health-detail__problem">Проблема</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in problemRows" :key="row.key">
                                        <td>
                                            <CLink v-if="row.path" :to="row.path">{{ row.title }}</CLink>
                                            <span v-else>{{ row.title }}</span>
                                        </td>
                                        <td>{{ row.problem }}</td>
                                        <td class="text-right">
                                            <CLink v-if="row.path" :to="row.path">Добавить картинку</CLink>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p v-else class="text-muted mb-0">Нет</p>
                    </section>

                    <section class="content-health-detail__section">
                        <h5>Простои</h5>
                        <div v-if="record.incidents && record.incidents.length" class="table-responsive">
                            <table class="table table-striped table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th class="content-health-detail__when">Начало</th>
                                        <th class="content-health-detail__when">Конец</th>
                                        <th>Причины</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="incident in record.incidents" :key="incident.id">
                                        <td>{{ formatDate(incident.openedAt) }}</td>
                                        <td>{{ incident.closedAt ? formatDate(incident.closedAt) : 'открыт' }}</td>
                                        <td>{{ reasonText(incident.reasons) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p v-else class="text-muted mb-0">Простоев нет</p>
                    </section>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';

    export default {
        name: 'ContentHealthDetail',

        data () {
            return {
                loading: false,
                record: {}
            };
        },

        computed: {
            problemRows () {
                const missing = (this.record.missingProducts || []).map(product => ({
                    key: 'empty-' + product.id,
                    title: product.title || ('#' + product.id),
                    problem: 'Пустое поле',
                    path: this.productPath(product.id)
                }));
                const files = (this.record.samples || []).map(sample => ({
                    key: 'file-' + sample.id,
                    title: sample.title || ('#' + sample.id),
                    problem: 'Файл не найден',
                    path: this.productPath(sample.id)
                }));
                return missing.concat(files);
            }
        },

        watch: {
            '$route.params.id': 'loadData',
            '$route.params.type': 'loadData'
        },

        mounted () {
            this.loadData();
        },

        methods: {
            formatDate (date) {
                return date ? moment(date).format('DD.MM.YYYY HH:mm') : '—';
            },
            formatUptime (value) {
                return value == null ? '—' : value + '%';
            },
            statusText (ok) {
                return ok ? 'ок' : 'не ок';
            },
            statusClass (ok) {
                return ok ? 'content-health-detail__stat-value text-success' : 'content-health-detail__stat-value text-danger';
            },
            reasonList (reasons) {
                return Array.isArray(reasons) ? reasons : [];
            },
            reasonText (reasons) {
                return this.reasonList(reasons).map(reason => reason.message).join('; ') || '—';
            },
            productPath (id) {
                const type = this.record.venueType;
                const venueId = this.record.venueId;
                const query = { focus: 'picture' };
                if (!id || !venueId) {
                    return null;
                }
                if (type === 'restaurant') {
                    return { path: '/restaurants/' + venueId + '/dishes/' + id + '/edit', query };
                }
                if (type === 'grocer') {
                    return { path: '/grocers/' + venueId + '/goods/' + id + '/edit', query };
                }
                if (type === 'pharmacy') {
                    return { path: '/pharmacies/' + venueId + '/drugs/' + id + '/edit', query };
                }
                if (type === 'entity' && this.record.adminPath) {
                    return { path: this.record.adminPath + '/products/' + id + '/edit', query };
                }
                return null;
            },
            loadData () {
                const { type, id } = this.$route.params;
                this.loading = true;
                Vue.axios
                    .get('/content-health/' + type + '/' + id)
                    .then(resp => {
                        this.record = resp.data || {};
                    })
                    .catch(err => {
                        this.record = {};
                        this.$root.$emit('showError', 'Ошибка загрузки карточки. ' + err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    };
</script>

<style scoped>
.content-health-detail__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.content-health-detail__heading {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
}

.content-health-detail__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
}

.content-health-detail__subtitle {
    color: #768192;
    font-size: 13px;
}

.content-health-detail__info {
    margin-bottom: 20px;
}

.content-health-detail__info th {
    width: 180px;
    font-weight: 600;
    vertical-align: middle;
}

.content-health-detail__info td {
    vertical-align: middle;
}

.content-health-detail__stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
}

.content-health-detail__stats--uptime {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-top: 12px;
}

.content-health-detail__stat {
    border: 1px solid #d8dbe0;
    border-radius: 4px;
    padding: 12px 16px;
    background: #fff;
}

.content-health-detail__stat-label {
    color: #768192;
    font-size: 12px;
    line-height: 1.3;
    margin-bottom: 6px;
}

.content-health-detail__stat-value {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.2;
}

.content-health-detail__section {
    margin-top: 28px;
}

.content-health-detail__section h5 {
    margin-bottom: 12px;
    font-size: 16px;
}

.content-health-detail__reasons {
    margin: 0;
    padding-left: 18px;
}

.content-health-detail__reasons li + li {
    margin-top: 4px;
}

.content-health-detail__problem,
.content-health-detail__when {
    width: 180px;
    white-space: nowrap;
}

.content-health-detail table td {
    vertical-align: middle;
}

@media (max-width: 991px) {
    .content-health-detail__stats,
    .content-health-detail__stats--uptime {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 575px) {
    .content-health-detail__header,
    .content-health-detail__heading {
        align-items: flex-start;
        flex-direction: column;
    }

    .content-health-detail__stats,
    .content-health-detail__stats--uptime {
        grid-template-columns: 1fr;
    }

    .content-health-detail__info th,
    .content-health-detail__problem,
    .content-health-detail__when {
        width: auto;
        white-space: normal;
    }
}
</style>
